export interface PreferenceResponseModel {
  body?: string;
  error?: string;
  id?: string;
  preferenceKey: string;
  preferenceValue?: string;
  userId?: string;
}

export enum SelectedPreferencesENUM {
  TASKBANK = 'TaskBank',
  MAINKPI = 'MainKPI',
  UNIFIEDVIEW = 'UnifiedView',
  KPI = 'KPI'
}